import { checkPermissions } from "../Services/Capabilities";

const AllowedAccess = ({
  userPermissions,
  allowedPermissions,
  children,
  renderNoAccess,
  allowedRoles,
  role,
}) => {
  let permitted =
    allowedPermissions.length > 0
      ? checkPermissions(userPermissions, allowedPermissions)
      : false;
  if (!permitted) {
    permitted = allowedRoles?.includes(role);
  }

  if (permitted) {
    return children;
  }
  return renderNoAccess();
};
AllowedAccess.defaultProps = {
  allowedPermissions: [],
  userPermissions: [],
  renderNoAccess: () => null,
  allowedRoles:[],
	role:"",

};
export default AllowedAccess;
